import { useEffect, useState } from 'react';

import Hoist from '@groww-tech-pvt/hoist';

const { getFeatureValue, getAttributes } = Hoist;


export type HoistKeyValueObject = {
  hoistKey: string;
  defaultValue: any;
}

const reduceHoistKeys = (hoistKeysAndDefaults: HoistKeyValueObject[]) => {
  const hoistValues = hoistKeysAndDefaults.reduce(
    (acc, { hoistKey, defaultValue }) => ({ ...acc, [hoistKey]: defaultValue }), {});

  return hoistValues;
};

export function useHoistValue(hoistKeysAndDefaults: HoistKeyValueObject[] | HoistKeyValueObject) {
  const hasMultipleHoistKeys = Array.isArray(hoistKeysAndDefaults);

  const [hoistValuesObj, setIsHoistValuesObj] = useState({
    isHoistLoading: true,
    hoistValue: hasMultipleHoistKeys ? reduceHoistKeys(hoistKeysAndDefaults as HoistKeyValueObject[]) : (hoistKeysAndDefaults as HoistKeyValueObject)?.defaultValue
  });

  const attributes = getAttributes();
  const { userId } = attributes ?? {};

  useEffect(() => {
    hasMultipleHoistKeys ? fetchMultipleFeatureValues() : fetchFeatureValues();
  }, [userId]);


  const fetchMultipleFeatureValues = async () => {
    try {
      const promises = (hoistKeysAndDefaults as HoistKeyValueObject[]).map(async ({ hoistKey, defaultValue }: { hoistKey: string; defaultValue: any }) => {
        const hoistValue = await getFeatureValue(hoistKey, defaultValue);

        return { [hoistKey]: hoistValue };
      });

      const hoistValues = await Promise.all(promises);
      const result = hoistValues.reduce((acc: Record<string, any>, value: Record<string, any>) => ({ ...acc, ...value }), {});

      setIsHoistValuesObj({
        isHoistLoading: false,
        hoistValue: result
      });

    } catch (error) {
      setIsHoistValuesObj({
        isHoistLoading: false,
        hoistValue: reduceHoistKeys(hoistKeysAndDefaults as HoistKeyValueObject[])
      });
    }
  };


  const fetchFeatureValues = async () => {
    const { hoistKey, defaultValue } = hoistKeysAndDefaults as HoistKeyValueObject ?? {};

    try {
      const hoistValue = await getFeatureValue(hoistKey, defaultValue);

      setIsHoistValuesObj({
        isHoistLoading: false,
        hoistValue: hoistValue
      });

    } catch (error) {
      setIsHoistValuesObj({
        isHoistLoading: false,
        hoistValue: defaultValue
      });
    }
  };

  return hoistValuesObj;

}
